import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

const STORAGE_KEY = "eva-theme";

export type ThemeMode = "light" | "dark";

function oppositeMode(mode: ThemeMode): ThemeMode {
    if (mode === "light") return "dark";
    return "light";
}

@Injectable({ providedIn: "root" })
export class ThemeService {
    private current: ThemeMode = "light";

    constructor(@Inject(PLATFORM_ID) private platformId: object) {}

    init(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "light" || stored === "dark") {
            this.current = stored;
        } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            this.current = "dark";
        }
        document.body.classList.add(this.current);
        document.documentElement.setAttribute("data-bs-theme", this.current);
    }

    getMode(): ThemeMode {
        return this.current;
    }

    // Logo reactivo al tema -- fuente única (admin usa su propia ruta relativa
    // en navegate.component; el flujo candidato usa esta, ruta desde root).
    logoSrc(): string {
        if (this.current === "dark") return "assets/logo-ia-eva-dark.svg";
        return "assets/logo-ia-eva.svg";
    }

    toggleMode(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        document.body.classList.toggle("light");
        document.body.classList.toggle("dark");
        this.current = oppositeMode(this.current);
        document.documentElement.setAttribute("data-bs-theme", this.current);
        localStorage.setItem(STORAGE_KEY, this.current);
    }
}
